import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5985f4fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Additional Information", -1))
const _hoisted_2 = { class: "checkout-details" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col--12 col-md--6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Where are you staying?", -1))
const _hoisted_6 = { class: "col--12 col-md--6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "How many times have you visited Scilly?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseRadio = _resolveComponent("BaseRadio")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, {
    errors: _ctx.v$.$errors,
    showMessage: false
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_BaseInput, {
              label: 'Accommodation name',
              placeholder: 'Accommodation name',
              name: "accomodationName",
              disabled: _ctx.isResident===true || _ctx.notBookedAccommodation===true,
              hasError: _ctx.v$.accomodationName.$error,
              errors: _ctx.v$.accomodationName.$errors,
              valid: !_ctx.v$.accomodationName.$invalid,
              modelValue: _ctx.v$.accomodationName.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.accomodationName.$model) = $event))
            }, null, 8, ["disabled", "hasError", "errors", "valid", "modelValue"]),
            _createVNode(_component_BaseCheckbox, {
              id: "notbooked",
              name: "notbooked",
              disabled: _ctx.isResident===true,
              label: 'Not yet booked',
              modelValue: _ctx.v$.notBookedAccommodation.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.notBookedAccommodation.$model) = $event))
            }, null, 8, ["disabled", "modelValue"]),
            _createVNode(_component_BaseDropdown, {
              label: 'Area',
              placeholder: 'Select an area',
              name: "accomodationArea",
              disabled: _ctx.isResident===true,
              hasError: _ctx.v$.accomodationArea.$error,
              errors: _ctx.v$.accomodationArea.$errors,
              valid: !_ctx.v$.accomodationArea.$invalid,
              modelValue: _ctx.v$.accomodationArea.$model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.accomodationArea.$model) = $event)),
              options: _ctx.accomodationAreaOptions
            }, null, 8, ["disabled", "hasError", "errors", "valid", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfVisitsOptions, (option, index) => {
              return (_openBlock(), _createBlock(_component_BaseRadio, {
                key: index,
                name: "visits",
                id: option.value,
                value: option.value,
                label: option.label,
                hasError: _ctx.v$.numberOfVisits.$error,
                errors: _ctx.v$.numberOfVisits.$errors,
                valid: !_ctx.v$.numberOfVisits.$invalid,
                modelValue: _ctx.v$.numberOfVisits.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.numberOfVisits.$model) = $event))
              }, null, 8, ["id", "value", "label", "hasError", "errors", "valid", "modelValue"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.numberOfVisits.$errors, (error, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-field__error",
                key: index
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["errors"]))
}